import { store } from "../store/store";

export function getUseSystemDarkModeSettings(): boolean {
    return store().useSystemDarkModeSettings;
}
